<template>

  <div>
    <lateralNavigation2></lateralNavigation2>
    <rightNav></rightNav>
  <div style="background: #FFFFFF; margin-top: 40px">
    <div class="userCenter warp">
      <div class="leftMenu">
        <div class="leftMenuBox">
          <el-menu :default-active="defaultActive" active-text-color="#FF7800" router>
            <el-menu-item class="flex-start" index="userInfo"><span>个人信息</span></el-menu-item>
            <el-menu-item class="flex-start" index="myOrder"><span>我的订单</span></el-menu-item>
           <el-menu-item class="flex-start" index="orderAfterSale"><span>售后订单</span></el-menu-item>
           <el-menu-item class="flex-start" index="myEvaluate"><span>我的评价</span></el-menu-item>
            <el-menu-item class="flex-start" index="signingAddress"><span>收货地址</span></el-menu-item>
            <el-menu-item class="flex-start" index="couponPackage"><span>劵 包</span></el-menu-item>
            <!-- <el-menu-item class="flex-start" index="changePwd"><span>更改密码</span></el-menu-item> -->
            <el-menu-item class="flex-start" index="changePhone"><span>更换手机号</span></el-menu-item>
            <el-menu-item class="flex-start" index="invoiceInfo"><span>发票管理</span></el-menu-item>
            <el-menu-item class="flex-start" index="foot"><span>我的足迹</span></el-menu-item>
            <el-menu-item class="flex-start" index="receiveCoupon"><span>领优惠券</span></el-menu-item>
            <el-menu-item class="flex-start" index="myCollect"><span>我的收藏</span></el-menu-item>
            <el-menu-item class="flex-start" index="maybeLike"><span>猜你喜欢</span></el-menu-item>
            <el-menu-item class="flex-start" index="message">
                <span>系统通知</span>
              <el-badge v-if="infoTotal>0" :value="infoTotal" class="item">
              </el-badge>
            </el-menu-item>
            <!-- <el-menu-item class="flex-start" index="unbindPhone"><span>解绑手机</span></el-menu-item> -->
          </el-menu>
        </div>
      </div>
      <div class="userCenterInfo">
        <router-view></router-view>
      </div>
    </div>
    <serve></serve>
  </div>
  </div>

</template>

<script>
import Cookie from 'js-cookie'
import {mapGetters, mapMutations} from "vuex";
import api from '../../api'
import {listSearchMixin} from '../../config/mixin'
import Serve from "../../components/serve/serve";
import lateralNavigation2 from "../../components/base/lateralNavigation2";
import rightNav from "../../components/canvasShow/rightNav";

export default {
  components: {Serve,lateralNavigation2,rightNav},
  mixins: [listSearchMixin],
  data(){
    return{
      total:0
    }
  },
  created () {
    if (!Cookie.get('token')) {
      this.$message({
        message: '请先登录'
      })
      this.$router.push({path: '/login'})
    }
  },
  name: 'userCenter',
  methods:{
    ...mapMutations({
      setInfoTotal: 'SET_INFOTOTAL'
    }),
  },
  computed: {
    ...mapGetters([
      'infoTotal' // 新增修改收货地址
    ]),

    defaultActive: function () {
      try{
        let self=this;
        let params = {
          url: api.messageTotal,
          method: 'GET',
          data: {
          }
        }
        self.sendReq(params, (res) => {
          // this.total=res.data;
          self.setInfoTotal(res.data)
        })
      }catch (e){

      }
      return this.$route.path.replace('/', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.leftMenuBox>>>.el-menu-item {
  font-size: 12px;
  height: 32px;
  line-height: 32px;
}
.item {
}
  .userCenter {
    background: #FFFFFF;
    margin-top: 30px;
    display: flex;
    margin-bottom: 140px;
    .leftMenu {
      width: 160px;
      border: 1px solid #E5E5E5;
      margin-right: 16px;
      .leftMenuBox {
        >>> .el-menu {
          border-right: none;
        }
        >>> .el-menu-item {
          padding: 0 !important;
          display: block;
          span {
            width: 100%;
            padding-left: 50px;
            border-left: 4px solid #ffffff;
          }
        }
        >>> .el-menu-item:focus, .el-menu-item:hover {
          background: none;
        }
        >>> .is-active {
          span {
            border-left: 4px solid $mainColor;
            box-sizing: content-box;
          }
        }
      }
    }
    .userCenterInfo {
      flex: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/userCenter/userCenter.vue